import { useEffect } from "react";
import MicroModal from "micromodal";
import styles from "./index.module.css";
import Button from "@/bricks/Button";
import { trackEvent } from "@/js/helpers/tracking";

const ProactiveChatModal = () => {
  useEffect(() => {
    MicroModal.init();
  }, []);

  const handleStartChat = (e) => {
    MicroModal.close("modal-proactive-chat");

    trackEvent({
      action: "elementClicked",
      data: {
        elementType: "BUTTON",
        position: "PROACTIVE CHAT MODAL",
        text: e.target.textContent.trim(),
      },
    });

    const chatButton = document.querySelector("#kore-chat-window .chat-circle");
    if (chatButton) {
      chatButton.click();
    }
  };

  const handleClose = (e) => {
    MicroModal.close("modal-proactive-chat");

    // Only track if user actually clicked a close button/overlay
    const isCloseButton =
      e.target.classList.contains("modal__close") ||
      e.target.classList.contains("modal__overlay");
    if (!isCloseButton) return;

    trackEvent({
      action: "elementClicked",
      data: {
        elementType: "BUTTON",
        position: "PROACTIVE CHAT MODAL",
        text: "Close",
      },
    });

    // Prevent clicks from bubbling up to the overlay and tracking elementClicked twice
    e.stopPropagation();
  };

  return (
    <section className={`component ${styles.component}`}>
      <div className="modal micromodal-slide" id="modal-proactive-chat">
        <div className="modal__overlay" tabIndex="-1" onClick={handleClose}>
          <div
            className={`modal__container ${styles.component__modalContainer}`}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-proactive-chat-title"
          >
            <button
              className={`modal__close ${styles.component__close}`}
              aria-label="Close modal"
              onClick={handleClose}
            />
            <div
              className={`modal__content ${styles.component__body}`}
              id="modal-proactive-chat-content"
            >
              <h2
                className={styles.component__header}
                id="proactive-chat-modal-title"
              >
                Need help?
              </h2>
              <p className={styles.component__text}>
                Our specialists are here to answer your questions about plans,
                installation and more.
              </p>

              <ul className={styles.component__list}>
                <li>
                  <i className={`${styles.component__icon} icon-fiber`} /> Plan
                  specs
                </li>
                <li>
                  <i className={`${styles.component__icon} icon-wrench`} />{" "}
                  Install details
                </li>
                <li>
                  <i className={`${styles.component__icon} icon-invoice`} />{" "}
                  Billing info
                </li>
              </ul>

              <Button
                className={styles.component__button}
                onClick={handleStartChat}
              >
                Start a live chat
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProactiveChatModal;
